import { render } from "./index.vue?vue&type=template&id=189e1ff3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=189e1ff3&lang=scss&scoped=true"

import exportComponent from "D:\\VueProject\\app\\app_store_static\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.4.38_vue@3.4.38_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189e1ff3"]])

export default __exports__